var _style, _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128.4 128.4",
    style: {
      enableBackground: "new 0 0 128.4 128.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:none;stroke:#47B649;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.2,3C30.5,3,3,30.5,3,64.2s27.5,61.2,61.2,61.2s61.2-27.5,61.2-61.2C125.4,30.4,98,3,64.2,3z M87.3,67 c-4.4,3.3-33.8,21.5-33.8,21.5s-4.3,2.4-4.5-2.8V42.2c0,0,0.8-5.5,6.8-1l31,20.2C87.3,61.8,91.6,63.7,87.3,67z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.3,95.4c0,1.6-1.3,3-3,3h-3c-1.6,0-3-1.3-3-3V33c0-1.6,1.3-3,3-3h3c1.6,0,3,1.3,3,3V95.4z M82,95.4 c0,1.6-1.3,3-3,3h-3c-1.6,0-3-1.3-3-3V33c0-1.6,1.3-3,3-3h3c1.6,0,3,1.3,3,3V95.4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.2,3C30.5,3,3,30.5,3,64.2s27.5,61.2,61.2,61.2s61.2-27.5,61.2-61.2C125.4,30.4,98,3,64.2,3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseBtn);
export default __webpack_public_path__ + "static/media/pause-btn.99b01e849673aecd29df7c7ea9fc77ec.svg";
export { ForwardRef as ReactComponent };